export const BDSFont = {
  font: {
    head1_ex: {
      fontSize: '36px',
      fontWeight: 200,
      lineHeight: '54px',
    },
    head1_sb: {
      fontSize: '36px',
      fontWeight: 600,
      lineHeight: '54px',
    },
    head2_ex: {
      fontSize: '32px',
      fontWeight: 200,
      lineHeight: '48px',
    },
    head2_sb: {
      fontSize: '32px',
      fontWeight: 600,
      lineHeight: '48px',
    },
    // head3 banner writer
    head3_bw: {
      fontSize: '26px',
      fontWeight: 600,
      lineHeight: '38px',
    },
    head4_b: {
      fontSize: '24px',
      fontWeight: 700,
      lineHeight: '32px',
    },
    head4_sb: {
      fontSize: '24px',
      fontWeight: 600,
      lineHeight: '32px',
    },
    head4_rank: {
      fontSize: '24px',
      fontWeight: 700,
      lineHeight: '30px',
    },
    head5_b: {
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '28px',
    },
    head5_sb: {
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: '28px',
    },
    head5_m: {
      fontSize: '20px',
      fontWeight: 500,
      lineHeight: '28px',
    },
    head5_r: {
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: '28px',
    },
    head6_b: {
      fontSize: '18px',
      fontWeight: 700,
      lineHeight: '26px',
    },
    head6_sb: {
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: '26px',
    },
    head6_m: {
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '26px',
    },
    head6_r: {
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: '26px',
    },
    body1_b: {
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: '24px',
    },
    body1_sb: {
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '24px',
    },
    body1_m: {
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '24px',
    },
    body1_r: {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
    },
    body2_b: {
      fontSize: '15px',
      fontWeight: 700,
      lineHeight: '22px',
    },
    body2_sb: {
      fontSize: '15px',
      fontWeight: 600,
      lineHeight: '22px',
    },
    body2_m: {
      fontSize: '15px',
      fontWeight: 500,
      lineHeight: '22px',
    },
    body2_r: {
      fontSize: '15px',
      fontWeight: 400,
      lineHeight: '22px',
    },
    body3_sb: {
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '20px',
    },
    body3_m: {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '20px',
    },
    body3_r: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
    },
    body4_sb: {
      fontSize: '13px',
      fontWeight: 600,
      lineHeight: '18px',
    },
    body4_m: {
      fontFeatureSettings: "'liga' off, 'clig' off",
      fontSize: '13px',
      fontWeight: 500,
      lineHeight: '18px',
    },
    body4_r: {
      fontFeatureSettings: "'liga' off, 'clig' off",
      fontSize: '13px',
      fontWeight: 400,
      lineHeight: '18px',
    },
    caption1_b: {
      fontSize: '12px',
      fontWeight: 700,
      lineHeight: '17px',
    },
    caption1_sb: {
      fontFeatureSettings: "'liga' off, 'clig' off",
      fontSize: '12px',
      fontWeight: 600,
      lineHeight: '17px',
    },
    caption1_m: {
      fontFeatureSettings: "'liga' off, 'clig' off",
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '17px',
    },
    caption1_r: {
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '17px',
    },
    caption2_sb: {
      fontSize: '11px',
      fontWeight: 600,
      lineHeight: '16px',
    },
    caption2_m: {
      fontSize: '11px',
      fontWeight: 500,
      lineHeight: '16px',
    },
    caption2_r: {
      fontSize: '11px',
      fontWeight: 400,
      lineHeight: '16px',
    },
    caption2_underline: {
      fontSize: '11px',
      fontWeight: 400,
      lineHeight: '16px',
      textDecorationLine: 'underline',
      textDecorationStyle: 'solid',
      textDecorationSkipInk: 'none',
      textDecorationThickness: 'auto',
      textUnderlineOffset: 'auto',
      textUnderlinePosition: 'from-font',
    },
    caption3_sb: {
      fontSize: '10px',
      lineHeight: '14px',
      fontWeight: 600,
    },
    caption3_r: {
      fontSize: '10px',
      lineHeight: '14px',
      fontWeight: 400,
    },
  },
} as const;
